"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRemoveVoucherErrorResponse = exports.RemoveVoucherFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'remove-voucher-failed';
const RemoveVoucherFailedEvent = exports.RemoveVoucherFailedEvent = Name;
const isRemoveVoucherErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isRemoveVoucherErrorResponse = isRemoveVoucherErrorResponse;
